import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import GuestGuard from 'utils/route-guard/GuestGuard';

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const CRVBoarding = Loadable(lazy(() => import('views/crv-boarding')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <GuestGuard>
            <MainLayout />
        </GuestGuard>
    ),
    children: [
        {
            path: '/sample-page',
            element: <SamplePage />
        },
        {
            path: '/crv-boarding',
            element: <CRVBoarding />
        }
    ]
};

export default MainRoutes;
